import { useEffect, useState } from "react";

export default function ContactHero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative pt-20 bg-[#1e1a16] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=elegant%20oriental%20energy%20jewelry%20Tibetan%20dzi%20bead%20crystal%20bracelet%20on%20dark%20stone%20surface%20with%20soft%20warm%20candlelight%20bokeh%20background%20luxury%20serene%20peaceful%20atmosphere%20high%20end%20photography%20warm%20amber%20tones&width=1920&height=600&seq=contact_hero001&orientation=landscape"
          alt="聯絡瓏靖手作能量"
          className="w-full h-full object-cover object-center opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1e1a16]/60 via-[#1e1a16]/50 to-[#1e1a16]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-16 pt-20 pb-20 text-center">
        <div
          className={`transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="w-10 h-px bg-[#c9a96e]"></span>
            <span
              className="text-[#c9a96e] text-[1rem] tracking-[0.35em] font-medium"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              CONTACT US
            </span>
            <span className="w-10 h-px bg-[#c9a96e]"></span>
          </div>
          <h1
            className="text-white font-bold mb-5 leading-[1.3]"
            style={{
              fontSize: "clamp(2rem, 4vw, 2.75rem)",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            聯絡我們
          </h1>
          <p
            className="text-white/60 max-w-lg mx-auto leading-[1.75]"
            style={{
              fontSize: "1.1875rem",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            無論是商品諮詢、訂製需求或能量飾品的選購建議，我們都很樂意為您服務。
          </p>
        </div>
      </div>
    </section>
  );
}
